import { Box, Button, Snackbar, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import './profile/profile.css';
import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { confirmPassVali, passwordValidator } from './validation';
import { useDispatch, useSelector } from 'react-redux';
import { changePassLoader, changePassReq, changePassSuccess } from '../../store/user/actions/changePasActions';
import { useHistory } from 'react-router';

const Changepassword = ()=> {

    const changePasState= useSelector(state => state.changePas)
    const dispatch = useDispatch({});
    const history = useHistory();
    const [changePass, setChangePass] = useState({
        current_password : '',
        new_password : '',
        confirm_password : '',
        curPasswordErr: '',
        newPasswordErr: '',
        comPasswordErr: '',
        showCurPassword:false,
        showNewPassword:false,
        showComPassword:false
      });
    
    const handleChange = (e) => {
        //  //console.loge.target);
        let names = e.target.name;
        let val = e.target.value;
        setChangePass({ ...changePass, [names]: val })
    }

    const handleCurShow = (e) => {
        setChangePass({
            ...changePass,
            showCurPassword: !changePass.showCurPassword
        });
    }
    const handleNewShow = (e) => {
        setChangePass({
            ...changePass,
            showNewPassword: !changePass.showNewPassword
        });
    }
    const handleComShow = (e) => {
        setChangePass({
            ...changePass,
            showComPassword: !changePass.showComPassword
        });
    }

    const handleSubmit=(e)=>{
        const curPassErr = passwordValidator(changePass.current_password);
        const newPassErr = passwordValidator(changePass.new_password);
        const comPassErr = confirmPassVali(changePass.confirm_password, changePass.new_password);

        if(curPassErr || newPassErr || comPassErr){
            setChangePass({
                ...changePass,
                curPasswordErr: curPassErr,
                newPasswordErr: newPassErr,
                comPasswordErr: comPassErr
            });
            return;
        }
        let data = {
            "current_password": changePass.current_password,
            "new_password": changePass.new_password,
            "confirm_password": changePass.confirm_password
        }
        dispatch(changePassReq(data, history))
        handleReset()
    }

    const handleReset =()=>{
        setChangePass({
            ...changePass,
            current_password : '',
            new_password : '',
            confirm_password : '',
            curPasswordErr: '',
            newPasswordErr: '',
            comPasswordErr: '',
            showCurPassword: false,
            showNewPassword: false,
            showComPassword: false
        });
    }

    const handleAlertClose = ()=>{
        dispatch(changePassSuccess())
    }


    return (
        <div>
            {changePasState ? (
                <Snackbar
                    anchorOrigin={{ vertical: 'top', horizontal: 'right', }}
                    open={changePasState.isLoading}
                    autoHideDuration={4000}
                    onClose={handleAlertClose}
                    message={changePasState.changePassMsg}
                    key={{ vertical: 'top', horizontal: 'right' }}
                />
            ):<span></span>}
             <Container fluid className="profileheader">
                <Row>
                    <Col xs={6} sm={6} md={8} lg={8} xl={8}>
                        <Box className="tltprofilename">Change Password</Box>
                    </Col>
                </Row>
            </Container>
            <Container>
                <Row className="itemRow">
                 
                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Row className="insideRow">
                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Box className="changepasswordbox">
                                    <Box className="changepasswordtlt">Current Password <span>*</span></Box>
                                    <Box className="inputfieldchangepassword">
                                    
                                    <TextField variant="outlined" 
                                        type={changePass.showCurPassword ? 'text' : 'password'}
                                        placeholder="Current Password"
                                        error={!!changePass.curPasswordErr}
                                        helperText={changePass.curPasswordErr}
                                        value={changePass.current_password}
                                        name="current_password"
                                        onChange={handleChange}
                                        InputProps={{ // <-- This is where the toggle button is added.
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        name="showCurPassword"
                                                        onClick={handleCurShow}
                                                        size="large">
                                                        {changePass.showCurPassword ? <Visibility /> : <VisibilityOff />}
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                    ></TextField>

                                    </Box>
                                </Box>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Box className="changepasswordbox">
                                    <Box className="changepasswordtlt">New Password <span>*</span></Box>
                                    <Box className="inputfieldchangepassword">
                                        <TextField variant="outlined"
                                            type={changePass.showNewPassword ? 'text' : 'password'}
                                            placeholder="New Password"
                                            name="new_password"
                                            value={changePass.new_password}
                                            error={!!changePass.newPasswordErr}
                                            helperText={changePass.newPasswordErr}
                                            onChange={handleChange}
                                            InputProps={{ // <-- This is where the toggle button is added.
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="toggle password visibility"
                                                            name="showNewPassword"
                                                            onClick={handleNewShow}
                                                            size="large">
                                                            {changePass.showNewPassword ? <Visibility /> : <VisibilityOff />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                        ></TextField>
                                    </Box>
                                </Box>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Box className="changepasswordbox">
                                    <Box className="changepasswordtlt">Confirm Password <span>*</span></Box>
                                    <Box className="inputfieldchangepassword">
                                        <TextField variant="outlined"
                                            type={changePass.showComPassword ? 'text' : 'password'}
                                            placeholder="Confirm Password"
                                            name="confirm_password"
                                            value={changePass.confirm_password}
                                            error={!!changePass.comPasswordErr}
                                            helperText={changePass.comPasswordErr}
                                            onChange={handleChange}
                                            InputProps={{ 
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="toggle password visibility"
                                                            name="showComPassword"
                                                            onClick={handleComShow}
                                                            size="large">
                                                            {changePass.showComPassword ? <Visibility /> : <VisibilityOff />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                        ></TextField>
                                    
                                    </Box>
                                </Box>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Box className="btnSect">
                                    <Button 
                                    className="btnsubmitchange"
                                    variant="contained"
                                    color="primary"
                                    onClick={handleSubmit}
                                    disabled={changePasState.isLoading}
                                    >Submit
                                    </Button>
                                    <Button 
                                    className="btncancelchange"
                                    variant="contained"
                                    color="secondary"
                                        onClick={handleReset}
                                    >Reset</Button>
                                </Box>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Changepassword 